import React from "react";
import Header from "./Header";

export default function PickupReport() {
  return (
    <div style={styles.pageContainer}>
      <Header title="Pickup Report" />

      <div style={styles.card}>
        {/* Email ID */}
        <div style={styles.formGroup}>
          <label style={styles.label}>Enter Email ID</label>
          <input type="email" placeholder="Enter Email ID" style={styles.input} />
        </div>

        {/* Date Range */}
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem" }}>
          <div style={{ flex: 1 }}>
            <label style={styles.label}>Start Date</label>
            <input type="date" style={styles.input} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={styles.label}>End Date</label>
            <input type="date" style={styles.input} />
          </div>
        </div>

        {/* Search Button */}
        <div style={styles.formGroup}>
          <button style={styles.searchBtn}>Search</button>
        </div>

        {/* Table */}
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th>ASN Number</th>
                <th>SKU</th>
                <th>Submitted Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "1rem" }}>
                  No data available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: "100vh",
    background: "#f5f6fa",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    maxWidth: "800px",
    margin: "2rem auto",
    background: "#fff",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
  },
  formGroup: {
    marginBottom: "1.5rem",
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    fontWeight: "600",
    color: "#333",
  },
  input: {
    width: "100%",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  searchBtn: {
    width: "100%",
    padding: "1rem",
    backgroundColor: "#E30016",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "1.1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  tableContainer: {
    marginTop: "2rem",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "0.75rem",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
  },
  td: {
    padding: "0.75rem",
    borderBottom: "1px solid #eee",
  },
};
